const isPlatformWeb = order => !order.appInfo || order.appInfo.origin === "web";

export { isPlatformWeb };
